import { UnassignTripGroupingsFromTripInput } from '../../lib/types/models/trip/trip-input'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function unassignTripGroupingsFromTrip(
  input: UnassignTripGroupingsFromTripInput & { tripId: number }
) {
  const { tripId, tripGroupingIds } = input
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.trips.unassignTripGroupingsFromTrip.url, { id: tripId }),
        { ids: tripGroupingIds }
      )
    )
    .delete()
}
